<article
    class="alert-card"
    [class.alert-card--critical]="isCritical()"
    [attr.aria-labelledby]="'alert-subject-' + alert().id"
>
    <header class="alert-card__header">
        <span class="alert-card__severity">{{ severity() }}</span>
        <span class="alert-card__state">{{ state() }}</span>
        <span class="alert-card__type">{{ alert().typeName }}</span>
    </header>

    <h3 class="alert-card__subject" [id]="'alert-subject-' + alert().id">{{ alert().subject }}</h3>
    <p class="alert-card__text">{{ alert().text }}</p>
    @if (hasLatestText()) {
        <p class="alert-card__text"><span class="alert-card__label">Latest:</span> {{ alert().lastText }}</p>
    }

    <dl class="alert-card__facts">
        <div>
            <dt>Occurrences</dt>
            <dd>{{ alert().count }}</dd>
        </div>
        <div>
            <dt>Raised</dt>
            <dd>{{ alert().raisedAt | date: "yyyy-MM-dd HH:mm:ss" : "UTC" }} UTC</dd>
        </div>
        <div>
            <dt>Last seen</dt>
            <dd>{{ alert().lastSeenAt | date: "yyyy-MM-dd HH:mm:ss" : "UTC" }} UTC</dd>
        </div>
    </dl>

    @if (history().length > 0) {
        <ul class="alert-card__history">
            @for (entry of history(); track entry.who) {
                <li>
                    {{ entry.who }} · {{ entry.at | date: "yyyy-MM-dd HH:mm:ss" : "UTC" }} UTC
                    @if (entry.comment) {
                        <p class="alert-card__comment">{{ entry.comment }}</p>
                    }
                </li>
            }
        </ul>
    }

    <section class="alert-card__deliveries">
        <h4 class="alert-card__label">Delivery</h4>
        <ul>
            @for (delivery of deliveries(); track $index) {
                <li [class.alert-card__delivery--failed]="delivery.isRetrying">
                    {{ delivery.destination }} ({{ delivery.channel }}): {{ delivery.status }}
                    @if (delivery.deliveredAt) {
                        · {{ delivery.deliveredAt | date: "yyyy-MM-dd HH:mm:ss" : "UTC" }} UTC
                    }
                    @if (delivery.isRetrying) {
                        · attempts: {{ delivery.attempts }}
                    }
                    @if (delivery.lastError) {
                        <div class="alert-card__error">Last error: {{ delivery.lastError }}</div>
                    }
                    @if (delivery.hasMovedAddress) {
                        <div class="alert-card__address">
                            Original posted to {{ delivery.originalAddress }}; the destination is now
                            {{ delivery.address }}
                        </div>
                    }
                </li>
            } @empty {
                <li class="alert-card__delivery--failed">No delivery: no configured destination took this alert.</li>
            }
        </ul>
    </section>

    @if (actions().length > 0) {
        <div class="alert-card__actions">
            @for (item of actions(); track item.action) {
                <button mat-flat-button type="button" (click)="openActionDialog(item.action)">{{ item.label }}</button>
            }
        </div>
    }
</article>
